import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import * as React from "react";

type Store = {
  bottomNavValue: string
  setBottomNavValue: (by: string) => void
}

const useStore = create<Store>()(
  devtools(
    persist(
      (set) => ({
        bottomNavValue: '',
        setBottomNavValue: (by: string) => set((state) => ({ bottomNavValue: by })),
      }),
      { name: 'useStore' },
    ),
  ),
)

export default useStore;